export default {
  GET_ALL_ORDERS: 'orders/GET_ALL_ORDERS',
  GET_ALL_ORDERS_START: 'orders/GET_ALL_ORDERS_START',
  GET_ALL_ORDERS_SUCCESS: 'orders/GET_ALL_ORDERS_SUCCESS',
  GET_ALL_ORDERS_FAILURE: 'orders/GET_ALL_ORDERS_FAILURE',

  CREATE_ORDER: 'orders/CREATE_ORDER',
  CREATE_ORDER_START: 'orders/CREATE_ORDER_START',
  CREATE_ORDER_SUCCESS: 'orders/CREATE_ORDER_SUCCESS',
  CREATE_ORDER_FAILURE: 'orders/CREATE_ORDER_FAILURE',

  GET_ORDER: 'orders/GET_ORDER',
  GET_ORDER_START: 'orders/GET_ORDER_START',
  GET_ORDER_SUCCESS: 'orders/GET_ORDER_SUCCESS',
  GET_ORDER_FAILURE: 'orders/GET_ORDER_FAILURE',
};
